import Button from '@atoms/Button/Button';
import Cta from '@atoms/Cta/Cta';
import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IHighlightModule } from '@models/IHighlightModule';
import PositioningEnum from '@models/enums/PositioningEnum';
import VariantTypeEnum from '@models/enums/VariantTypeEnum';
import classNames from 'classnames';

const HighlightModule = ({
  site,
  image,
  imagePosition,
  header,
  text,
  ctaButton,
  ctaStyle,
}: IHighlightModule) => {
  return (
    <section className="tw-container tw-mx-auto tw-bg-grey-10 tw-text-grey-100">
      <div
        className={classNames(
          imagePosition === PositioningEnum.Left
            ? 'md:tw-flex-row'
            : 'md:tw-flex-row-reverse',
          'tw-flex tw-flex-col md:tw-min-h-[376px] lg:tw-min-h-[400px] xl:tw-min-h-[480px]'
        )}
      >
        <div className="tw-flex tw-h-auto md:tw-w-1/2">
          <Image
            imageClasses="tw-h-full tw-object-cover tw-w-full"
            classes="tw-w-full"
            image={image}
          />
        </div>
        <div className="tw-flex tw-h-auto tw-flex-col tw-items-start tw-justify-center tw-gap-sm tw-px-xs tw-py-sm md:tw-w-1/2 md:tw-p-md lg:tw-p-xl">
          <Text variant="headline" className="tw-max-w-[700px]">
            {header}
          </Text>
          {text && (
            <Text variant="body" className="tw-max-w-[600px] tw-text-grey-80">
              {text}
            </Text>
          )}
          {ctaButton.url && ctaButton.text && (
            <>
              {ctaStyle === VariantTypeEnum.Cta ? (
                <Cta
                  site={site}
                  url={ctaButton.url}
                  text={ctaButton.text}
                  target={ctaButton.target}
                />
              ) : (
                <Button
                  site={site}
                  as="link"
                  variant={ctaStyle === 'primary' ? 'grey30' : 'yellow'}
                  href={ctaButton.url}
                  label={ctaButton.text}
                />
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default HighlightModule;
